id<template>
  <div class="cont_wrap xj_record">
    <iCol span="24">
      <template>
        <Tabs v-model="tabsSelect" :animated="false">
          <TabPane
            v-for="tab in standardsTab"
            :key="tab"
            :label="module[tab]"
            :name="tab"
          >
            <temp-record
              v-if="tabsSelect == tab && tab == '1'"
              :type="tab"
              :deviceId="deviceId"
            ></temp-record>
            <speed-record
              v-if="tabsSelect == tab && tab == '2'"
              :type="tab"
              :deviceId="deviceId"
            ></speed-record>
            <acc-speed-record
              v-if="tabsSelect == tab && tab == '3'"
              :type="tab"
              :deviceId="deviceId"
            ></acc-speed-record>
            <high-acc-speed-record
              v-if="tabsSelect == tab && tab == '4'"
              :type="tab"
              :deviceId="deviceId"
            ></high-acc-speed-record>
            <offset-record
              v-if="tabsSelect == tab && tab == '5'"
              :type="tab"
              :deviceId="deviceId"
            ></offset-record>
            <electricity-record
              v-if="tabsSelect == tab && tab == '6'"
              :type="tab"
              :deviceId="deviceId"
            ></electricity-record>
            <unquantize-record
              v-if="tabsSelect == tab && tab == '0'"
              :type="tab"
              :deviceId="deviceId"
            ></unquantize-record>
            <picture-record
              v-if="tabsSelect == tab && tab == '-1'"
              :type="tab"
              :deviceId="deviceId"
            ></picture-record>
            <other-record
              v-if="
                tabsSelect == tab &&
                tab != '-1' &&
                tab != '0' &&
                tab != '1' &&
                tab != '2' &&
                tab != '3' &&
                tab != '4' &&
                tab != '5' &&
                tab != '6'
              "
              :type="tab"
              :deviceId="deviceId"
            ></other-record>
          </TabPane>
        </Tabs>
      </template>
    </iCol>
  </div>
</template>

<script>
import tempRecord from "./temp-record";
import speedRecord from "./speed-record";
import accSpeedRecord from "./acc-speed-record";
import highAccSpeedRecord from "./high-acc-speed-record";
import offsetRecord from "./offset-record";
import electricityRecord from "./electricity-record";
import unquantizeRecord from "./unquantize-record";
import pictureRecord from "./picture-record";
import otherRecord from "./other-record";
import getRandVal, { getTime } from "@/assets/js/index";
import Base64 from "@/assets/js/base64.js";
import md5 from "js-md5";
import { getDate } from "@/assets/js/tools";
export default {
  name: "inspection-record",
  props: {
    deviceId: "",
  },
  data() {
    return {
      choice: {},
      currentDeviceId: "",
      currentUrl: "",
      standardsTab: [],
      tabsSelect: "",
      module: {
        /*'1':'温度',
                    '2':'速度',
                    '3':'加速度',
                    '4':'高频加速度',
                    '5':'位移',
                    '6':'电流',
                    '0':'非量化',
                    '-1':'图片',*/
      },
    };
  },
  mounted() {
    console.log(this.deviceId);
    this.getStandards();
  },
  watch: {
    /*       choice(newVal, oldVal) {
                this.currentDeviceId = newVal.id;
                this.getStandards();
            }*/
  },
  methods: {
    //获取数据开始
    getPwdHash(pwd, data) {
      var sha = md5(pwd + data);
      var base = new Base64();
      var pwdHashStr = base.encode(sha);
      return pwdHashStr;
    },
    getStandards() {
      this.module = {};
      let id = this.deviceId;
      let url = "mcbw/device_patrol_standards/standards_patrol";
      var data = {
        type: "get",
        url: url + "/" + id,
        obj: {},
      };
      this.$Axios(data).then((res) => {
        if (res.data.success) {
          if (res) {
            let data = res.data.data;
            if (data && data.length > 0) {
              data.map((val) => {
                if (val.patrolStandardType == "-1") {
                  this.module["-1"] = "图片";
                } else if (
                  val.patrolStandardType == "0" ||
                  val.patrolStandardType == ""
                ) {
                  this.module[val.patrolStandardType] = "非量化";
                } else if (val.patrolStandardType) {
                  this.module[val.patrolStandardType] =
                    val.patrolStandardTypeName;
                }
              });
            }
            const type = [];
            let datalist = res.data.data;
            for (var i = 0; i < datalist.length; i++) {
              if (
                datalist[i].patrolStandardType 
              ) {
                let tt = datalist[i].patrolStandardType;
                type.push(tt.toString());
              }
            }
            this.tabsSelect = type[0];

            this.standardsTab = type;
          }
        }
      });
    },
    /*reset(name) {
                this.$refs[name].resetFields();
            }*/
  },
  components: {
    tempRecord,
    speedRecord,
    accSpeedRecord,
    highAccSpeedRecord,
    offsetRecord,
    electricityRecord,
    unquantizeRecord,
    pictureRecord,
    otherRecord,
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-tabs-bar {
  //border-bottom: 1px solid #08F4F7;
}
.cont_wrap {
  height: 100%;
  /deep/ .ivu-col-span-24 {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/riskRecord/riskRecord.vue